



























import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import LeaverRuleForm from '@/components/leaversTool/LeaverRuleForm.vue';
import { LeaversToolConfigurationsService } from '@/services/LeaversTool/LeaversToolConfigurationsService';
import { DocumentTypeModel, LeaverRuleCreateUpdateModel, LeaversToolConfigurationModel } from '@/types';
import { ArrayUtils } from '@/utils';

export default Vue.extend({
  name: 'AddLeaverRule',
  props: {
    configurationId: {
      required: true
    }
  },
  data() {
    return {
      rule: {
        configurationId: this.configurationId
      } as LeaverRuleCreateUpdateModel,
      configuration: {} as LeaversToolConfigurationModel,
      isPageLoading: false
    };
  },
  async mounted() {
    this.isPageLoading = true;
    this.configuration = await LeaversToolConfigurationsService.getAsync(this.configurationId as number);
    this.configuration.configurableCurrentDocumentTypes = ArrayUtils.alphabeticalSort(this.configuration.configurableCurrentDocumentTypes, (x) => x.description);
    this.configuration.configurableDestinationDocumentTypes = ArrayUtils.alphabeticalSort(this.configuration.configurableDestinationDocumentTypes, (x) => x.description);
    this.isPageLoading = false;
  },
  components: {
    LoadingSpinner,
    LeaverRuleForm
  }
});
